import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import classes from './Assessment.module.scss'
import Icon from '../../../Icon'
import Button from '../../shared/ComponentLibrary/RButton'
import SelectInputField from '../../shared/ComponentLibrary/RSelectInputField'
import { SelectChangeEvent } from '@mui/material/Select';

type GridAreaProps = {
  innerText: string
  onClickMethod?: (event: React.MouseEvent<HTMLButtonElement>) => void
  variant?: "text" | "contained" | "outlined" | undefined
  backColor?: string
  gridArea?: string,
  mt?: number,
  align?: string,
  disabled?: boolean
}

const GridAreaButton = ({ innerText, onClickMethod, variant, backColor=undefined, gridArea, mt, align='flex-start', disabled = false }: GridAreaProps) => {
  return (
    <Box sx={{ gridArea: gridArea, visibility: onClickMethod ? 'visible' : 'hidden', mt: mt , display:'flex', justifyContent:align}}>
      <Button innerText={innerText} onClickMethod={onClickMethod} variant={variant} backColor={backColor} disabled={disabled} />
    </Box>
  )
}

const OtherAssessment = ({ assessmentProps, enabled }: OtherAssessmentControlProps) => {
  const { name, languages } = assessmentProps!;
  const [pickedLanguage, setPickedLanguage] = useState<string | null>(null)

  const handleLanguageDropdownChange = (event: SelectChangeEvent) => {
    setPickedLanguage(event.target.value as string)
  };

  useEffect(() => {
    if (languages.length === 1) {
      //initial dropdown value is not handled by handleLanguageDropdownChange.
      //Without this useEffect hook the language-specific fields in the table
      //won't match unless the user picks the language explicitly, even though
      //there is only one.
      setPickedLanguage(languages[0].val);
    }
  }, [])

  const getPickedLanguageObj = () => {
    if (pickedLanguage === null) {
      return null;
    }
    let pickedList = languages.filter(language => language.val === pickedLanguage);
    return pickedList[0];
  }

  const takenDate = (dateString: string | null | undefined) => dateString ? new Date(dateString) : null;

  const formattedDate = (dateString: string | null | undefined) => takenDate(dateString)?.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });

  const formattedTime = (dateString: string | null | undefined) => takenDate(dateString)?.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return (
    <div className={classes.profile_step_container}>
      <div className={classes.step_container}>
        <div className={classes.step_non_anchor}>
          <div className={`${classes.step} ${classes.other_assessment}`}>
            <div className={classes.step_content_frame}>
              <Icon name='page100Copy' size='28' />
              <Box className={classes.step_content} sx={{ml: 3}}>
                <div className={classes.step_title}>{name}</div>
                {languages.some(x => true) && <Box className={classes.optional_langs} sx={{ gridArea: "langs" }}>
                  <Box sx={{gridArea: "title"}}><label className={classes.label}>Languages</label></Box>
                  <Box sx={{ gridArea: "dropdown" }}>
                    <SelectInputField
                      value={languages.length === 1 ? languages[0].val : ''}
                      label=''
                      name='Languages'
                      size='parent'
                      placeholderOverride='Select Language'
                      onChange={handleLanguageDropdownChange}
                      register={{}}
                      itemsList={languages.map(language => {
                        return {
                          name: language.language + (language.takenAt ? ` (Taken on ${formattedDate(language.takenAt)} at ${formattedTime(language.takenAt)})` : ''),
                          value: language.val
                        }
                      }
                      )}
                    />
                  </Box>
                  <Box sx={{gridArea: "statusText"}}>
                    {
                      getPickedLanguageObj()?.assessmentMessage ? (
                      <div>
                        <Box className={classes.step_subtitle} sx={{mt: 1}}>
                        {getPickedLanguageObj()?.assessmentMessage}
                        </Box>
                      </div>
                      ) : null
                    }
                  </Box>
                  <Box sx={{ gridArea:"statusIcon", display: 'flex', alignItems: 'center', ml:1, mb:1 }}>
                    {
                      getPickedLanguageObj() && (getPickedLanguageObj()?.takenAt ?
                        <Icon name='checkmarkGreen' size='28' /> :
                        <Icon name='highPriorityFilled' size='28' />
                    )}
                  </Box>
                </Box>
                }
                <GridAreaButton innerText='Instructions' onClickMethod={getPickedLanguageObj()?.onInstructionsClickMethod} gridArea='instructions' variant='outlined' backColor='#fff' mt={1} />

                <GridAreaButton innerText='Practice Test' onClickMethod={getPickedLanguageObj()?.onPracticeTestClickMethod} gridArea='practice' variant='outlined' backColor='#fff'  mt={1} align='center' />

                <GridAreaButton innerText='Start Test' onClickMethod={getPickedLanguageObj()?.onStartTestClickMethod} gridArea='start' variant='outlined' backColor='#fff'  mt={1} align='flex-end' disabled={!enabled} />
              </Box>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default OtherAssessment
